var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import AreaRow from '@/components/area-row/AreaRow';
import { UserSubject } from '@/models/UserSubject';
import SelectFilter from '@/components/select-filter/SelectFilter';
import LoaderCard from '@/components/loader-card/LoaderCard';
let CreateIdpDialog = class CreateIdpDialog extends Vue {
    constructor() {
        super(...arguments);
        this.selectedStudents = [];
        this.selectedPeriods = {};
        this.selectedLevels = {};
        this.filters = {
            periods: [],
            levels: [],
        };
        this.currentStep = 1;
        this.areas = [];
        this.isLoading = true;
        this.curriculum = new CurriculumModel();
        this.selectedSubjects = [];
        this.selectedIdpType = null;
    }
    mounted() {
        this.selectedSubjects = [];
        this.selectedStudents = this.students;
        this.initialize();
    }
    initialize() {
        this.isLoading = true;
        this.areas = [];
        new CurriculumModel()
            .current()
            .first()
            .then((curriculum) => {
            this.curriculum = curriculum;
            if (curriculum.id) {
                this.getSubjects(curriculum.id);
            }
        });
    }
    removeStudent(studentId) {
        this.selectedStudents = this.selectedStudents.filter((student) => {
            return student.id !== studentId;
        });
    }
    close() {
        this.clear();
        this.$emit('input', false);
        this.currentStep = 1;
    }
    clear() {
        this.$store.dispatch('selectedChanged', null);
        this.$store.dispatch('checkboxReset', true);
        this.selectedIdpType = null;
        this.selectedSubjects = [];
    }
    handleAreaDeleted(area) {
        const key = this.areas.findIndex((subject) => subject.id === area.area.id);
        this.areas.splice(key, 1);
    }
    getSubjects(curriculumId, extendedFilters = {}) {
        extendedFilters.curriculum = this.curriculum.id;
        Object.keys(this.filters).forEach((key) => {
            if (this.filters[key] === null || this.filters[key].length === 0) {
                return;
            }
            extendedFilters[key] = this.filters[key];
        });
        new Subject()
            .filter(extendedFilters)
            .limit(100)
            .include('children')
            .all()
            .then((subjects) => {
            this.areas = subjects;
            this.curriculum.subjects = subjects;
            this.isLoading = false;
        });
    }
    filterCurriculum() {
        this.selectedSubjects = this.$store.state.selected;
        this.selectedSubjects.forEach((selectedSubject) => {
            if (!selectedSubject.parent) {
                return;
            }
            this.$store.state.curriculum.subjects.forEach((area) => {
                if (!area.children) {
                    return;
                }
                const topics = area.children.filter((subject) => {
                    return subject.id === selectedSubject.parent.id;
                });
                if (topics.length) {
                    selectedSubject.parent.parent = area;
                }
            });
        });
    }
    create() {
        if (!this.selectedSubjects) {
            return;
        }
        this.isLoading = true;
        const subjects = [];
        const users = [];
        this.selectedSubjects.forEach((selectedSubject) => {
            if (selectedSubject.id) {
                subjects.push(selectedSubject.id);
            }
        });
        this.selectedStudents.forEach((student) => {
            if (student.id) {
                users.push(student.id);
            }
        });
        const payload = {
            subjects,
            users,
            status: this.selectedIdpType,
        };
        new UserSubject()
            .bulkUpdateSubjectToStudents(payload)
            .then(() => {
            this.clear();
            this.$emit('subjectsAdded', this.selectedIdpType === 'future' ? true : false);
            this.isLoading = false;
        })
            .catch((error) => {
            this.isLoading = false;
            this.currentStep = 2;
        });
    }
    deleteSelectedSubject(index) {
        this.selectedSubjects.splice(index, 1);
    }
    currentStepChanged() {
        if (this.currentStep === 2) {
            this.filterCurriculum();
        }
        if (this.currentStep === 3) {
            this.create();
        }
    }
    studentsChanges(students) {
        this.selectedStudents = students;
    }
    levelFilterChange(newValue) {
        if (this.curriculum.id) {
            this.getSubjects(this.curriculum.id);
        }
    }
};
__decorate([
    Prop({ default: [] }),
    __metadata("design:type", Array)
], CreateIdpDialog.prototype, "students", void 0);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateIdpDialog.prototype, "currentStepChanged", null);
__decorate([
    Watch('students'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], CreateIdpDialog.prototype, "studentsChanges", null);
__decorate([
    Watch('filters', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CreateIdpDialog.prototype, "levelFilterChange", null);
CreateIdpDialog = __decorate([
    Component({
        components: {
            AreaRow,
            SelectFilter,
            LoaderCard,
        },
    })
], CreateIdpDialog);
export default CreateIdpDialog;
